var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changeBetAmount as changeBetAmountAction } from '../../../actions/coupon/creators/coupon';
import { getResourceAmount, resourceNames } from '../../../constants/accountResourceNames';
import { isRateUnavailable } from '../rateUtils';
import _Input from './_Input';
import RenderBetItem from './RenderBetItem';
import { cssClassMap } from '../../../constants/SportCssMap';
import StakeVariants from '../StakeVariants';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import * as BetStatus from '../../../constants/BetStatus';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
var messages = defineMessages({
    bets_potential_return: {
        id: 'bets.potential_return',
        defaultMessage: 'Возможный выигрыш:'
    },
    coupon_stake_amount: {
        id: 'coupon.stake_amount',
        defaultMessage: 'Сумма ставки'
    },
    coupon_total_odd: {
        id: 'coupon.total_odd',
        defaultMessage: 'Общий коэффициент'
    }
});
var Express = /** @class */ (function (_super) {
    __extends(Express, _super);
    function Express() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.targetElement = null;
        _this.deleteBetSlip = function (id) {
            _this.props.deleteBetSlipAction(id);
        };
        _this.changeAmount = function (e) {
            if (!_this.props.freebetToggled) {
                _this.props.changeBetAmountAction(e.target.value.replace(/\D/g, ''));
            }
        };
        _this.addBtnHandler = function (couponAmountValue, amount) {
            _this.props.changeBetAmountAction(+couponAmountValue + amount);
        };
        _this.subtractBtnHandler = function (couponAmountValue, amount) {
            if (+couponAmountValue >= amount) {
                _this.props.changeBetAmountAction(+couponAmountValue - amount);
            }
        };
        return _this;
    }
    Express.prototype.componentDidMount = function () {
        this.targetElement = document.querySelector('#items');
        disableBodyScroll(this.targetElement);
    };
    Express.prototype.componentWillUnmount = function () {
        clearAllBodyScrollLocks();
    };
    Express.prototype.renderItem = function (bet, index, languageId) {
        var disabled = isRateUnavailable(bet.get('rate'));
        var bettingState;
        if (bet.get('unavailable') === true) {
            disabled = true;
            bettingState = bet.get('bettingState');
        }
        var props = {
            match: bet.get('match'),
            outcome: bet.get('outcome'),
            rate: bet.get('rate'),
            deleteBetSlip: this.deleteBetSlip,
            prompt: this.props.prompt,
            betSlipsPromptClose: this.props.betSlipsPromptClose,
            disabled: disabled,
            languageId: languageId,
            bettingState: bettingState,
            currency: resourceNames[this.props.user.accountResourceId]
        };
        var itemCls = "item ".concat(cssClassMap[bet.get('rate').get('sportId')]);
        return (_jsx("div", __assign({ className: itemCls }, { children: _jsx("div", __assign({ className: 'item-inner' }, { children: _jsx(RenderBetItem, __assign({}, props)) })) }), index));
    };
    Express.prototype.render = function () {
        var _this = this;
        var _a = this.props, betSlips = _a.betSlips, couponAmount = _a.couponAmount, odd = _a.odd, errorCode = _a.errorCode, intl = _a.intl, languageId = _a.languageId, freebetToggled = _a.freebetToggled, freebet = _a.freebet, status = _a.status, client = _a.client;
        var isBigStake = status === BetStatus.STAKE_REQUEST;
        var renderBetSlip = [];
        betSlips.map(function (bet, i) {
            renderBetSlip.push(_this.renderItem(bet, i, languageId));
        });
        var couponAmountValue = freebetToggled ? freebet.amount : couponAmount;
        var currency = resourceNames[this.props.user.accountResourceId];
        var amount = getResourceAmount(this.props.user.accountResourceId, client.country);
        if (couponAmountValue !== '') {
            localStorage.setItem('couponAmountValue', couponAmountValue);
        }
        var getLocalStorage = Number(localStorage.getItem('couponAmountValue'));
        var savedCouponAmountValue = getLocalStorage > 0 ? getLocalStorage : '';
        var possibleWin = Math.ceil((odd * (couponAmountValue || savedCouponAmountValue)) * 1000) / 1000;
        return (_jsxs(Fragment, { children: [_jsx("div", __assign({ className: 'items', id: 'items' }, { children: renderBetSlip })), _jsxs("div", __assign({ className: 'data' }, { children: [_jsx(FormattedMessage, __assign({}, messages.coupon_total_odd)), " ", _jsx("strong", __assign({ className: 'rate', id: 'express_factor' }, { children: odd }))] })), _jsxs("div", __assign({ className: 'add' }, { children: [_jsxs("span", __assign({ className: 'stake-label' }, { children: [_jsx(FormattedMessage, __assign({}, messages.bets_potential_return)), _jsxs("span", { children: [_jsx("span", __assign({ className: 'possible-win-amount' }, { children: possibleWin ? possibleWin.toFixed(2) : possibleWin })), " ", currency] })] })), _jsxs("div", __assign({ className: 'control' }, { children: [_jsxs("span", { children: [_jsx("button", { className: 'subtract-btn', onClick: function () { return _this.subtractBtnHandler(savedCouponAmountValue, amount); } }), _jsx(_Input, { changeAmount: this.changeAmount, freebetToggled: freebetToggled, couponAmount: savedCouponAmountValue, placeholder: intl.formatMessage(messages.coupon_stake_amount), error: errorCode }), _jsx("button", { className: 'add-btn', onClick: function () { return _this.addBtnHandler(savedCouponAmountValue, amount); } })] }), !isBigStake && this.props.showError] }))] })), _jsx(StakeVariants, { freebetToggled: freebetToggled })] }));
    };
    return Express;
}(React.Component));
Express.propTypes = {
    betSlips: PropTypes.object.isRequired,
    gridLocalization: PropTypes.object.isRequired,
    couponAmount: PropTypes.any.isRequired,
    selectedBetType: PropTypes.object.isRequired,
    prompt: PropTypes.bool.isRequired,
    errorCode: PropTypes.number.isRequired,
    betSlipsPromptClose: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    languageId: PropTypes.number.isRequired,
    showError: PropTypes.any.isRequired,
    freebetToggled: PropTypes.bool.isRequired,
    freebet: PropTypes.object.isRequired,
    balance: PropTypes.number.isRequired,
    user: PropTypes.object.isRequired,
    client: PropTypes.object.isRequired,
};
function mapStateToProps(state, props) {
    var selectedBetType = props.selectedBetType.betType;
    var odd = 0;
    var betTypes = state.coupon.get('betTypes');
    var betType = betTypes.find(function (b) {
        return b.type === selectedBetType;
    });
    var balance = state.balance.value;
    if (betType) {
        odd = betType.odd;
    }
    return {
        user: state.auth.user,
        odd: odd,
        balance: balance,
        languageId: state.application.get('languageId'),
        client: state.application.get('client'),
    };
}
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    changeBetAmountAction: changeBetAmountAction
}, dispatch); };
Express = connect(mapStateToProps, mapDispatchToProps)(Express);
export default injectIntl(Express);



// WEBPACK FOOTER //
// ./src/components/coupon/betTypesComponents/MultiBet.jsx